module.exports = __webpack_public_path__ + "media/images/themes/mcdonalds_culture_service/logo-4cc3d7d46e011f20f3aeb71dad81efb5.png";